<template>
  <div class="flex flex-col items-center gap-4 mb-4" style="position: relative; min-height: 200px;">
    <V3ImageComponent src="icons/error.png" class="w-48" />
    <p class="text-md font-semibold text-center">{{ data.message }}</p>
    <p class="text-center">{{ data.description }}</p>

    <div class="flex flex-col w-full gap-2" v-if="data.oosError?.length > 0">
      <div class="p-2 bg-gray-100 w-full border" v-for="(item, index) in data.oosError" :key="index">
        <p>{{ item.name }} [Available: {{ item.available }}]</p>
      </div>
    </div>

    <!-- Configurable button at bottom-right -->
    <div class="flex w-full justify-end mt-2">
      <button v-if="data.button?.label && data.button?.action" @click="data.button.action()"
        class="px-4 py-2 bg-primary text-white font-semibold rounded shadow hover:bg-primary-700 transition">
        {{ data.button.label }}
      </button>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});
</script>
